module.exports = __webpack_public_path__ + "static/11500-border-128966a21d2bcc5e2a4c3b644e72dbf3.jpg";